export default "__VITE_ASSET__5e4c5f6c__"